import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrWF: CultureInfo = {
  name: 'fr-WF',
  displayName: 'français (Wallis-et-Futuna)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-WF',
  parent: CultureInfoFr
};
